var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Link = function Link(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M21.571 8.793a4.536 4.536 0 0 0-3.207-1.329h-.707a1 1 0 0 0 0 2h.707a2.535 2.535 0 0 1 0 5.072h-5.667a2.5 2.5 0 0 1-2.525-2.526 1 1 0 1 0-2-.02 4.5 4.5 0 0 0 4.54 4.545h5.652a4.535 4.535 0 0 0 3.207-7.742Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M14.51 8.782a4.5 4.5 0 0 0-3.222-1.318H5.636a4.536 4.536 0 0 0 0 9.071h.707a1 1 0 1 0 0-2h-.707a2.535 2.535 0 1 1 0-5.07h5.667a2.5 2.5 0 0 1 2.525 2.525 1 1 0 1 0 2 .02 4.5 4.5 0 0 0-1.317-3.228Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Link;